import { fetchSprintfitCatalog } from './fetchSprintfitCatalog';

let inflight = null;
/** @type {any[] | null | undefined} */
let resolved = undefined;

/**
 * Single shared catalog fetch for the SPA (live API or catalog-fallback.json).
 * Resolves once per page load; returns null if both sources fail.
 */
export function getSprintfitCatalogSingleton() {
  if (resolved !== undefined) return Promise.resolve(resolved);
  if (!inflight) {
    inflight = fetchSprintfitCatalog(48).then((data) => {
      resolved = data;
      inflight = null;
      return data;
    });
  }
  return inflight;
}
